import { Action, createReducer, on } from '@ngrx/store';
import { IDistributionChart } from '../models/user-analytics.model';
import * as actions from '../actions';

export const getAgeDistributionChartKey = 'getAgeDistributionChartData';
export interface AgeDistributionChartState {
  loadAgeDistributionChartResponse: IDistributionChart[];
  loadAgeDistributionChartResponseFailure: any;
  loaded: boolean;
}

export const initialState: AgeDistributionChartState = {
  loadAgeDistributionChartResponse: undefined,
  loadAgeDistributionChartResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadAgeDistributionChart, (state, action) => ({
    ...state
  })),
  on(actions.loadAgeDistributionChartSuccess, (state, action) => ({
    ...state,
    loadAgeDistributionChartResponse: action.response,
    loaded: true
  })),
  on(actions.loadAVCFrequencyLookupsFailure, (state, action) => ({
    ...state,
    loadAgeDistributionChartResponseFailure: action.error
  }))
);

export const getAgeDistributionChart = (state: AgeDistributionChartState) => {
  if (state && state.loadAgeDistributionChartResponse) return JSON.parse(JSON.stringify(state.loadAgeDistributionChartResponse));
  else return null;
};

export const getAgeDistributionChartIsLoaded = (state: AgeDistributionChartState) => {
  state.loaded;
};
